import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class NavigationService {

	noBackRoutes = [
		'/$',
		'/login$',
		'/register$',
		'/forgot-password$',
		'/change-user-password$',
		'/change-expired-password$',
		'/reset-password*',
		'/confirm-user-email*',
		'/non-confirmed-user-email*',
		'/terms-and-conditions$',
		'/privacy-policy$',
		'/contact-us$',
	];

	publicRoutes = [
		'/terms-and-conditions',
		'/privacy-policy',
	];

	private currentUrl: string = undefined;

	//Holds the last valid previous URL (not 404/unauthorized)
	private latestPreviousUrl = '';

	//Ignore URLs as previous if they redirect to these
	private ignorePrevious = ['/404', '/unauthorized'];

	constructor(private router: Router) {
		this.currentUrl = router.url;
		router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if(this.ignorePrevious.includes(event.urlAfterRedirects)) {
					this.latestPreviousUrl = event.url;
				}
				this.setPreviousUrl(this.currentUrl);
				this.currentUrl = event.url;
			};
		});
	}

	setPreviousUrl(url, remove = false) {

		if(remove) {
			sessionStorage.removeItem('previousUrl');
			return;
		}

		if(url && url != this.latestPreviousUrl) {
		
			let save = true;
			for(const route of this.noBackRoutes) {
				if(new RegExp("^"+route, "g").test(url)) {
					save = false;
					break;
				}
			}

			if(save)
				sessionStorage.setItem('previousUrl', url);
		}
	}

	isPublicUrl(url) {
		if(!url)
			return false;

		return this.publicRoutes.includes(url.split('?')[0]);
	}

	getPreviousUrl() {
		return sessionStorage.getItem('previousUrl');
	}

	goBack(defaultUrl:any) {
		const backUrl = this.getPreviousUrl();
		if(backUrl && backUrl != '/' && this.currentUrl != backUrl)
			return this.navigate(backUrl);
		return this.navigate(defaultUrl);
	}

	navigate(url:string) {
		if(!url.includes('?'))
			return this.router.navigate([url]);
		
		const urlParsed = url.split('?');
		const urlString = urlParsed.shift();
		const queryParamsSplitted = urlParsed.join('?').split('&');
		const queryParams:any = {};
		for(const item of queryParamsSplitted) {
			const temp = item.split('=');
			queryParams[temp[0]] = temp[1];
		}

		return this.router.navigate([urlString], {queryParams});
	}
}